/* eslint-disable prefer-destructuring */
import reactions from '../../core/reactions';

export const operations = reactions.operations;
export const selectors = reactions.selectors;
export default reactions;
